/**
 * Discord OAuth sign-in — only allowlisted accounts can use the app.
 */
import { LogIn } from "lucide-react";
import { APP_COPYRIGHT, APP_VERSION_LABEL } from "@memes/shared";

export const Login: React.FC = () => {
  // Tell the server exactly which callback URL to use (must match Discord portal + .env).
  const callback = `${window.location.origin}/api/v1/auth/discord/callback`;
  const loginUrl = `/api/v1/auth/discord?redirect_uri=${encodeURIComponent(callback)}`;

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 p-8">
      <div className="card max-w-md p-8 text-center">
        <img
          src="/icon.png"
          alt=""
          className="mx-auto mb-4 h-16 w-16 rounded-2xl object-cover shadow"
        />
        <h1 className="text-xl font-bold">Memes &amp; Shit</h1>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          Sign in with Discord to access the jukebox. Only approved accounts can log in.
        </p>
        <a
          href={loginUrl}
          className="btn btn-primary mt-6 inline-flex items-center gap-2"
        >
          <LogIn className="h-4 w-4" />
          Sign in with Discord
        </a>
        <p className="mt-6 text-[10px] uppercase tracking-wider text-gray-400">
          {APP_VERSION_LABEL}
        </p>
        <p className="mt-1 text-[10px] text-gray-400">{APP_COPYRIGHT}</p>
      </div>
    </div>
  );
};
